/**
 * Which top-level sections have a side menu.
 *
 * Its own module, with zero imports, for two reasons:
 *
 * 1. `MainLayout` needs it to decide whether to render the rail. Importing it
 *    from `SideMenu.tsx` means importing a 440-line component to read a
 *    constant — and that component pulls in `react-router-dom`, which broke a
 *    unit test that only wanted the constant. Same coupling lesson as
 *    `activeLocale()` reading the i18next singleton rather than the app's init
 *    module.
 * 2. It is shared configuration, not part of the component's implementation.
 *
 * WHY A WHITELIST
 * ---------------
 * `MainLayout` used to decide with `activeSection !== 'Dashboard'` — a blacklist
 * of exactly one. `activeSection` is the capitalised first path segment, so every
 * top-level route that is not a module passed the test and rendered a 240px
 * column containing nothing but the collapse chevron. Two routes hit it:
 * `/account/security`, the only top-level route under `MainLayout` with no menu
 * of its own. A whitelist fails in the safe direction — an unknown section gets
 * no rail rather than an empty one.
 *
 * MAINTENANCE
 * -----------
 * Adding a section to `menuConfig` in `SideMenu.tsx` without adding it here
 * hides that section's entire navigation. `src/i18n/sideMenuSections.test.ts`
 * reads the config out of the source and fails if the two sets differ, and
 * `SideMenu` logs loudly in development as a second gate.
 */
export const SIDE_MENU_SECTIONS: ReadonlySet<string> = new Set([
  'Organization',
  'Processes',
  'Attendance',
  'Integrations',
  'System',
]);
